export default {
  items: [
    {
      name: 'Dashboard',
      visible: 1,
      url: '/dashboard',
      icon: 'icon-speedometer',
      badge: {
        variant: 'primary'
      }
    },
    {
      name: 'Purchase',
      visible: 0,
      icon: 'icon-basket-loaded',
      children:[
        {
          name: 'Purchase Orders',
          visible: 0,
          url: '/pos',
        },
        {
          name: 'Goods Receive Note',
          visible: 0,
          url: '/grns',
        }
      ]
    },
    {
      name: 'Warehouse',
      visible: 0,
      icon: 'icon-drawer',
      children:[
        {
          name: 'Transfer Order',
          visible: 0,
          url: '/wtos',
        },
        {
          name: 'Transfer Receiving',
          visible: 0,
          url: '/wtrs',
        },
        {
          name: 'Stock Requisition Form',
          visible: 0,
          url: '/srfs',
        },
        {
          name: 'Stock Requisition Return',
          visible: 0,
          url: '/srrs',
        },
        {
          name: 'Stock Issuance',
          visible: 0,
          url: '/wsis',
        },
        {
          name: 'Sales Cancellation',
          visible: 0,
          url: '/wscs',
        },
        {
          name: 'Stock Adjustment Note',
          visible: 0,
          url: '/sans',
        },
        {
          name: 'Goods Return Outwards',
          visible: 0,
          url: '/gros',
        },
        {
          name: 'Goods Return Inwards',
          visible: 0,
          url: '/gris',
        },
      ]
    },
    {
      name: 'Stock Enquiry',
      visible: 0,
      icon: 'icon-puzzle',
      children:
      [
        {
          name: 'Stock Card Movement',
          visible: 0,
          url: '/scm',
        },
        {
          name: 'Stock Balance Record',
          visible: 0,
          url: '/sbr',
        }
      ]
    },
    {
      name: 'Proof Of Delivery',
      visible: 0,
      url: '/pods',
      icon: 'icon-wallet'
    },
    {
      name: 'Reports',
      visible: 0,
      icon: 'icon-docs',
      children:
      [
          {
            name: 'Product Delivered Report',
            visible: 0,
            url: '/pdr',
          },
          {
            name: 'Product Un-Delivered Report',
            visible: 0,
            url: '/pur',
          },
          {
            name: 'Back Order Report',
            visible: 0,
            url: '/bor',
          },
          {
            name: 'PO & GRN Tracking Reports',
            visible: 0,
            url: '/po_grn_tracking',
          },
          {
            name: 'SRF DO Listing Report',
            visible: 0,
            url: '/srf_do_listing',
          },
          {
            name: 'SR Usage Report',
            visible: 0,
            url: '/sr_usage',
          },
          {
            name: 'GRI Details Report',
            visible: 0,
            url: '/gri_details',
          },
      ]
    },
  ]
}

if (localStorage.auth_acl)
{
  var acl = localStorage.auth_acl.split(',')
  var items, n, vc  

  items = this.a.items[1]
  items.children[0].visible = acl.indexOf('po') + 1 || acl.indexOf('*') + 1
  items.children[1].visible = acl.indexOf('grn') + 1 || acl.indexOf('*') + 1
  for (n = 0, vc = 0; n < items.children.length; n++)
    if (items.children[n].visible)
      vc++;
  items.visible= vc > 0 || acl.indexOf('*') + 1

  items = this.a.items[2]
  items.children[0].visible = acl.indexOf('wto') + 1 || acl.indexOf('*') + 1
  items.children[1].visible = acl.indexOf('wtr') + 1 || acl.indexOf('*') + 1
  items.children[2].visible = acl.indexOf('srf') + 1 || acl.indexOf('*') + 1
  items.children[3].visible = acl.indexOf('srr') + 1 || acl.indexOf('*') + 1
  items.children[4].visible = acl.indexOf('wsi') + 1 || acl.indexOf('*') + 1
  items.children[5].visible = acl.indexOf('wsc') + 1 || acl.indexOf('*') + 1
  items.children[6].visible = acl.indexOf('san') + 1 || acl.indexOf('*') + 1
  items.children[7].visible = acl.indexOf('gro') + 1 || acl.indexOf('*') + 1
  items.children[8].visible = acl.indexOf('gri') + 1 || acl.indexOf('*') + 1
  for (n = 0, vc = 0; n < items.children.length; n++)
    if (items.children[n].visible)
      vc++;
  items.visible= vc > 0 || acl.indexOf('*') + 1

  items = this.a.items[3]
  items.children[0].visible = acl.indexOf('scm') + 1  || acl.indexOf('*') + 1
  items.children[1].visible = acl.indexOf('sbr') + 1  || acl.indexOf('*') + 1
  for (n = 0, vc = 0; n < items.children.length; n++)
    if (items.children[n].visible)
      vc++;
  items.visible= vc > 0 || acl.indexOf('*') + 1

  this.a.items[4].visible = acl.indexOf('pod') + 1 || acl.indexOf('*') + 1

  items = this.a.items[5]
  items.children[0].visible = acl.indexOf('pdr') + 1  || acl.indexOf('*') + 1
  items.children[1].visible = acl.indexOf('pur') + 1  || acl.indexOf('*') + 1
  items.children[2].visible = acl.indexOf('bor') + 1  || acl.indexOf('*') + 1
  items.children[3].visible = acl.indexOf('po_grn_tracking') + 1  || acl.indexOf('*') + 1
  items.children[4].visible = acl.indexOf('srf_do_listing') + 1  || acl.indexOf('*') + 1
  items.children[5].visible = acl.indexOf('sr_usage') + 1  || acl.indexOf('*') + 1
  items.children[6].visible = acl.indexOf('gri_details') + 1  || acl.indexOf('*') + 1

  for (n = 0, vc = 0; n < items.children.length; n++)
    if (items.children[n].visible)
      vc++;
  items.visible= vc > 0 || acl.indexOf('*') + 1

}



// WEBPACK FOOTER //
// ./src/_nav.js